module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fb-Gb-Hc-Ia.7bf88347.png";